import React from "react";
import logo from "../assets/logow.png"

export default function Footer() {
  return (
    <footer className="bg-[#101828] text-slate-200">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="py-12 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-10">
          <div className="md:col-span-2">
            <img
              src={logo}
              alt="Imdady"
              className="h-8 w-auto"
              onError={(e) => (e.currentTarget.style.display = "none")}
            />
            <p className="mt-3 text-sm text-slate-400 max-w-sm">
              The complete solution for game and food management businesses.
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-white mb-3">Product</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li>Features</li>
              <li>Pricing</li>
              <li>Security</li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-white mb-3">Company</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li>About Us</li>
              <li>Blog</li>
              <li>Careers</li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-white mb-3">Legal</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li>Privacy</li>
              <li>Terms</li>
              <li>Contact</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/60 py-6 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-slate-400">
          <span>© {new Date().getFullYear()} Imdady. All rights reserved.</span>
          <div className="flex items-center gap-4">
            <span>Facebook</span>
            <span>Twitter</span>
            <span>LinkedIn</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
